import dispatcher from '../dispatcher/dispatcher.js';

export function setUser(jwt){
    dispatcher.dispatch({
        type: 'SET_USER_DATA',
        object: jwt
    });
}
export function setStage(index){
    dispatcher.dispatch({
        type: 'SET_USER_STAGE',
        object: index
    });
}
export function logoutUser(){
    dispatcher.dispatch({
        type: 'LOGOUT_USER'
    });
}
export function setLogout(logout){
    dispatcher.dispatch({
        type: 'LOGOUT_USER',
        object: logout
    });
}


// WEBPACK FOOTER //
// ./src/action/userActions.js